import Repository from "@/axios.config.js";

// baseURL (BASE_URI) jest ustawiony w axios.config.js - tu tylko sciezki wzgledne.
const resource = "/home";

export default {
  getToken() {
    return Repository.get(`${resource}/getToken`);
  },
  getOrderDetails(orderNumber) {
    return Repository.get(`${resource}/getOrderByNumber`, {
      params: { orderNumber },
    });
  },
  addPhoneNumber(data, token) {
    return Repository.post(`${resource}/addPhoneNumber`, data, {
      headers: {
        "X-CSRF-TOKEN-HEADERNAME": token,
      },
    });
  },
};
